import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Utensils, Heart } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    icon: Calendar,
    image: 'https://cdn.magicpatterns.com/uploads/v9ChoaYrBberEwi75DKkPo/BONO_1.png',
    title: 'BONO #1 – Planner de Quincena Inteligente',
    description: 'No es una hoja de Excel fría. Es una herramienta práctica, visual y humana. Convierte la quincena en algo predecible y manejable, incluso si ganas "lo justo". No necesitas ser experta en finanzas. Solo necesitas seguir el flujo.',
    color: 'bg-blue-50 text-blue-900 border-blue-100',
    iconColor: 'text-blue-600'
  }, {
    icon: Utensils,
    image: 'https://cdn.magicpatterns.com/uploads/9ucm5XUnJzgctoDyrZdGF8/BONO_2.png',
    title: 'BONO #2 – Menú Anti-Quincena Rota',
    description: 'La comida mal planificada es uno de los mayores drenajes de dinero. Este menú demuestra que ahorrar no significa comer mal. Un plan de 7 días para comer bien sin que tu sueldo desaparezca en la cocina ni en pedidos de último momento.',
    color: 'bg-green-50 text-green-900 border-green-100',
    iconColor: 'text-green-600'
  }, {
    icon: Heart,
    image: 'https://cdn.magicpatterns.com/uploads/c5mpvRXkhjhac2bUcovn8Q/BONO3.png',
    title: 'BONO #3 – Ritual de Cierre de Quincena',
    description: 'Este bono ataca a la culpa financiera. Una guía breve pero poderosa para revisar tu quincena en solo 10 minutos, sin estrés y sin reproches. Porque castigarte no mejora tu dinero. Entenderlo, sí.',
    color: 'bg-rose-50 text-rose-900 border-rose-100',
    iconColor: 'text-rose-600'
  }];
  return <section className="py-24 bg-[#FFFBEB]" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-950 mb-6" data-id="element-47">
            Y para que no tengas que "pensar cómo hacerlo"...
          </h2>
          <p className="text-xl text-amber-800" data-id="element-48">
            No solo recibes el ebook. También te llevas{' '}
            <span className="font-bold" data-id="element-49">
              3 bonos diseñados para la práctica
            </span>
            , no la teoría.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-50">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className={`rounded-2xl border ${bonus.color} shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group`} data-id="element-51">
              {/* Image Section */}
              <div className="relative h-64 overflow-hidden bg-gradient-to-b from-amber-900/5 to-transparent" data-id="element-52">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-500" data-id="element-53" />
              </div>

              {/* Content Section */}
              <div className="p-8 relative z-10" data-id="element-54">
                <div className="flex items-center gap-2 mb-4" data-id="element-55">
                  <span className="text-xs font-bold uppercase tracking-wider bg-white/50 px-2 py-1 rounded" data-id="element-56">
                    Gratis
                  </span>
                  <span className="text-xl" data-id="element-57">🎁</span>
                </div>

                <h3 className="text-xl font-bold mb-4 leading-tight" data-id="element-58">
                  {bonus.title}
                </h3>

                <p className="text-sm opacity-90 leading-relaxed" data-id="element-59">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}